import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {InformType} from '../../../../global/util/enum/InformType';
import {Constant} from '../../../../global/util/Constant';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {AuthorityService} from '../../../service/authority.service';
import {AddEditAuthorityComponent} from '../add-edit-authority/add-edit-authority.component';
import {Authority} from '../../../model/Authority';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {ApplicationService} from '../../../service/application.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Module} from '../../../model/Module';
import {CloneTool} from '../../../../global/util/CloneTool';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-list-authority',
  templateUrl: './list-authority.component.html',
  styleUrls: ['./list-authority.component.css']
})
export class ListAuthorityComponent implements OnInit {
  public authorities: Authority[] = [];
  public moduleIdSelected: number;
  public moduleSelected: Module;
  public page: any = {};
  public links: any = {};
  private authorityUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public entityName = 'TITLE.PERMISSIONS';
  public modules: Module[];
  public term2Search: string;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public authorityService: AuthorityService,
              public modalService: NgbModal,
              public authenticationService: AuthService,
              public applicationService: ApplicationService,
              public translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.modules = LocalStorage.getModulesExtra();
    this.moduleSelected = this.modules[Constant.ZERO_INDEX];
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.loadDefaultData();
  }

  private loadDefaultData() {
    this.loadAuthorities(Page.First);
  }

  public search() {
    this.reloadAuthorities();
  }

  public reloadAuthorities() {
    this.loadAuthorities(Page.First);
  }

  public loadAuthorities(page: Page): void {
    if (this.term2Search === undefined) {
      this.term2Search = '';
    }
    switch (page) {
      case Page.First:
        this.authorityUrl = Constant.ROOT_API_V1
          .concat('/modules/')
          .concat(String(this.moduleSelected.id))
          .concat('/authorities')
          .concat('?findby=')
          .concat(this.term2Search)
          .concat('&size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.authorityUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.authorityUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.authorityUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.authorityUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getAuhtorities(this.authorityUrl);
  }

  private getAuhtorities(url: string) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.PERMISSIONS');
    this.authorityService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.authorities = next._embedded.authorities;
      } else {
        this.authorities = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openAddModal() {
    this.entityName = this.translate.instant('TITLE.PERMISSIONS');
    const modalRef = this.modalService.open(AddEditAuthorityComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.authority = new Authority();
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadAuthorities(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName, this.translate.instant('MESSAGE.PERMIT-ALREADY-REGISTERED'));
      }
    });
  }

  public openEditModal(authority: Authority) {
    this.entityName = this.translate.instant('TITLE.PERMISSIONS');
    const authority2Edit = CloneTool.do(authority);
    const modalRef = this.modalService.open(AddEditAuthorityComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.authority = authority2Edit;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadAuthorities(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openModalDelete(authority: Authority) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-PERMISSION');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-PERMISSIONS');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteAuthority(authority);
      }
    });
  }

  private deleteAuthority(authority: Authority) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.PERMISSIONS');
    this.authorityService.delete(authority).subscribe(authority1 => {
      this.loading = false;
      LocalStorage.updateAuthorities(authority1, Constant.DELETE);
      this.loadAuthorities(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.entityName);
    });
  }

  public getModuleDescription(module: number): string {
    return this.modules.find(value => value.id === module).description;
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }
}
